

import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const OverTime_Report  = createAsyncThunk(
    'report/fetchAllOvertimeReport',
    async (year : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/overtime?${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Overtime Report');
        }
    }
);
export const OverTime_Report_monthly  = createAsyncThunk(
    'report/fetchAllOvertimeReportmonthly',
    async ({month , year}: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/overtime/month?month=${month}&year=${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Overtime Report');
        }
    }
);
export const OverTime_Report_summary = createAsyncThunk(
    'report/fetchAllOvertimeReportsummary',
    async (_: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/overtime/summary`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Overtime Report');
        }
    }
);